import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { carePlanQueryKeys, carePlanQueryOptions } from "@/api/provider/patient/care-plan-query";

/**
 * Fetches care plans for a patient via `listForPatient` and seeds
 * each individual `detail` query cache entry so that downstream
 * consumers (e.g. PatientCarePlanViewer) read from the cache
 * instead of firing separate network requests.
 */
export function useCarePlansForPatient(patientId, options) {
  const $ = _c(11);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== patientId) {
    t0 = carePlanQueryOptions.listForPatient(patientId);
    $[0] = patientId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options) {
    t1 = options?.enabled !== undefined && {
      enabled: options.enabled
    };
    $[2] = options;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      ...t0,
      ...t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const query = useQuery(t2);
  let t3;
  let t4;
  if ($[7] !== query.data || $[8] !== queryClient) {
    t3 = () => {
      if (!query.data) {
        return;
      }
      for (const cp of query.data) {
        queryClient.setQueryData(carePlanQueryKeys.detail(cp.id), cp);
      }
    };
    t4 = [query.data, queryClient];
    $[7] = query.data;
    $[8] = queryClient;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  return query;
}